import axios from "axios";
import { environment } from "../environments/environment";
import { AuthService } from "src/app/authentication/auth.service";
import axiosInstance from "src/app/polar-SAAS-Components/axios-instance"
export const getCorporates = async () => {
  const userId = AuthService.getUserId();
  const token = AuthService.getAccessToken();

  if (!userId || !token) {
    throw new Error("Missing user ID or access token");
  }

  const url = environment.host + "/user/" + userId + "/corporate";

  const response = await axios.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  return response.data;
};

export const getProject = async (corporateId?: string) => {
  const userId = AuthService.getUserId();
  const token = AuthService.getAccessToken();

  if (!userId || !token) {
    throw new Error("Missing user ID or access token");
  }

  let url = `${environment.host}/user/${userId}/project`;

  if (corporateId) {
    url += `?corporate=${corporateId}`;
  }

  const response = await axios.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return response;
};

export const getProjectsForUser = async (corporateId: string | null = null) => {
  const userId = AuthService.getUserId();
  const token = AuthService.getAccessToken();

  if (!userId || !token) {
    throw new Error("Missing user ID or access token");
  }

  const baseUrl = `${environment.host}/user/${userId}/project`;
  const url = corporateId ? `${baseUrl}?corporate=${corporateId}` : baseUrl;

  const response = await axios.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return response;
};

export const getKits = async () => {
  const userId = AuthService.getUserId();
  const token = AuthService.getAccessToken();

  if (!userId || !token) {
    throw new Error("Missing user ID or access token");
  }

  const path  ="/user/" + userId + "/kits";

  const response = await axiosInstance.get(path) ;

  return response;
};

export const getKitsByProject = async (projectId: string) => {
  const userId = AuthService.getUserId();
  const token = AuthService.getAccessToken();

  if (!userId || !token) {
    throw new Error("Missing user ID or access token");
  }

  const path  = `/user/${userId}/project/${projectId}/kit`;
  const response = await axiosInstance.get(path);
  return response;
};

export const createCorporate = async (corporateData: any) => {
  const userId = AuthService.getUserId();
  const token = AuthService.getAccessToken();

  if (!userId || !token) {
    throw new Error("Missing user ID or access token");
  }

  const url = `${environment.host}/user/${userId}/corporate`;

  const response = await axios.post(url, corporateData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return response;
};

export const getCorporate = async () => {
  const userId = AuthService.getUserId();

  if (!userId) {
    throw new Error("Missing user ID");
  }
 const url = `/user/${userId}/corporate`;
 
  const response = await axiosInstance.get(url);
  return response;
  
}


export const updateCorporate = async (corporateId: string, value: any) => {
  const userId = AuthService.getUserId();
  const token = AuthService.getAccessToken();

  if (!userId || !token) {
    throw new Error("Missing user ID or access token");
  }

  const url = `${environment.host}/user/${userId}/corporate/${corporateId}`;

  const response = await axios.put(url, value, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return response;
};

export const deleteCorporate = async (corporateId: string) => {
  const userId = AuthService.getUserId();
  const token = AuthService.getAccessToken();

  if (!userId || !token) {
    throw new Error("Missing user ID or access token");
  }

  const url = `${environment.host}/user/${userId}/corporate/${corporateId}`;

  const response = await axios.delete(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getUsersOfCorporate = async (corporateId: string) => {
  const userId = AuthService.getUserId();
  const token = AuthService.getAccessToken();

  if (!userId || !token) {
    throw new Error("Missing user ID or access token");
  }

  const url = `${environment.host}/user/${userId}/corporate/${corporateId}/system-user`;

  const response = await axios.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getUsersOfKit = async (kitId: string) => {
  const userId = AuthService.getUserId();
  const token = AuthService.getAccessToken();

  if (!userId || !token) {
    throw new Error("Missing user ID or access token");
  }

  const url = `${environment.host}/user/${userId}/kit/${kitId}/system-user`;

  const response = await axios.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const createProject = async (value: any) => {
  const userId = AuthService.getUserId();
  const token = localStorage.getItem("ACCESS_TOKEN");

  if (!userId || !token) {
    throw new Error("Missing user ID or access token");
  }

  const url = `${environment.host}/user/${userId}/project`;
  try {
    const response = await axios.post(url, value, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return {  response };
  } catch (error) {
    return { error: error.response ? error.response.data : error.message };
  }
}
export const updateProject = async (projectId: string, value: any) => {
  const userId = AuthService.getUserId();
  const token = localStorage.getItem("ACCESS_TOKEN");

  if (!userId || !token) {
    throw new Error("Missing user ID or access token");
  }

  const url = `${environment.host}/user/${userId}/project/${projectId}`;

  const response = await axios.put(url, value, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return response;
};

export const deleteProject = async (projectId: string) => {
  const userId = AuthService.getUserId();
  const token = AuthService.getAccessToken();

  if (!userId || !token) {
    throw new Error("Missing user ID or access token");
  }

  const url = `${environment.host}/user/${userId}/project/${projectId}`;

  const response = await axios.delete(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getUsersOfProject = async (projectId: string) => {
  const userId = AuthService.getUserId();
  const token = AuthService.getAccessToken();

  if (!userId || !token) {
    throw new Error("Missing user ID or access token");
  }

  const url = `${environment.host}/user/${userId}/project/${projectId}/system-user`;

  const response = await axios.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getProjectSummary = async (projectId: string) => {
  const userId = AuthService.getUserId();
  const token = AuthService.getAccessToken();

  if (!userId || !token) {
    throw new Error("Missing user ID or access token");
  }

  const url = `${environment.host}/user/${userId}/project/${projectId}/summary`;

  const response = await axios.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};
declare const google: any;

export type LatLng = { lat: number; lng: number };
export type Position = LatLng & { address?: string; accuracy?: number };

let googleMapsApiLoaded = false;
let loadingPromise: Promise<void> | null = null;

function hasGoogle(): boolean {
  return !!((window as any).google && (window as any).google.maps);
}

function hasPlaces(): boolean {
  return !!(
    (window as any).google &&
    (window as any).google.maps &&
    (window as any).google.maps.places &&
    (window as any).google.maps.places.AutocompleteService
  );
}

function hasGeocoder(): boolean {
  return !!(
    (window as any).google &&
    (window as any).google.maps &&
    (window as any).google.maps.Geocoder
  );
}

export function loadGoogleMaps(apiKey: string): Promise<void> {
  if (googleMapsApiLoaded) return Promise.resolve();
  if (loadingPromise) return loadingPromise;

  loadingPromise = new Promise<void>(function (resolve, reject) {
    if (hasGoogle()) {
      googleMapsApiLoaded = true;
      resolve();
      return;
    }

    var s = document.createElement("script");
    s.src = "https://maps.googleapis.com/maps/api/js?key=" + apiKey + "&libraries=places";
    s.async = true;
    (s as any).defer = true;

    s.onload = function () {
      googleMapsApiLoaded = true;
      resolve();
    };
    s.onerror = function (err) {
      reject(err);
    };
    document.body.appendChild(s);
  });

  return loadingPromise;
}

export function getPlacePredictions(
  input: string,
  bounds?: any,
  strictBounds: boolean = true
): Promise<any[]> {
  return new Promise(function (resolve, reject) {
    if (!hasPlaces()) {
      reject(new Error("Google Places not loaded"));
      console.log('google places not loaded')
      return;
    }

    var svc = new google.maps.places.AutocompleteService();
    svc.getPlacePredictions(
      {
        input: input,
        bounds: bounds,
        strictBounds: strictBounds,
        types: ["establishment", "geocode"]
      },
      function (preds: any, status: any) {
        if (status === "OK" && preds) {
          resolve(preds);
        } else if (status === "ZERO_RESULTS") {
          resolve([]);
        } else {
          reject(new Error("Autocomplete failed: " + status));
        }
      }
    );
  });
}

export function geocodePlaceId(placeId: string): Promise<LatLng> {
  return new Promise(function (resolve, reject) {
    if (!hasGeocoder()) {
      reject(new Error("Google Geocoder not loaded"));
      return;
    }

    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ placeId: placeId }, function (results: any, status: any) {
      if (status === "OK" && results && results[0] && results[0].geometry && results[0].geometry.location) {
        var loc = results[0].geometry.location;
        resolve({ lat: loc.lat(), lng: loc.lng() });
      } else {
        reject(new Error("Geocode failed: " + status));
      }
    });
  });
}

export function reverseGeocode(lat: number, lng: number): Promise<string | null> {
  return new Promise(function (resolve, reject) {
    if (!hasGeocoder()) {
      reject(new Error("Google Geocoder not loaded"));
      return;
    }

    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: { lat: lat, lng: lng } }, function (results: any, status: any) {
      if (status === "OK" && results && results[0]) {
        resolve(results[0].formatted_address || null);
      } else if (status === "OK") {
        resolve(null);
      } else {
        reject(new Error("Reverse geocode failed: " + status));
      }
    });
  });
}

export function getCurrentLocation(
  options: PositionOptions = { enableHighAccuracy: true, timeout: 30000, maximumAge: 30000 }
): Promise<Position> {
  return new Promise(function (resolve, reject) {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation not supported"));
      console.log('geolocation not initiated')
      return;
    }
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        var lat = pos.coords.latitude;
        var lng = pos.coords.longitude;
        console.log('geolocation  initiated',lat,lng)
        reverseGeocode(lat, lng)
          .then(function (address) {
            resolve({
              lat: lat,
              lng: lng,
              address: address || undefined,
              accuracy: pos.coords.accuracy
            });
          })
          .catch(function () {
            resolve({
              lat: lat,
              lng: lng,
              accuracy: pos.coords.accuracy
            });
          });
      },
      function (err) {
        reject(err);
      },
      options
    );
  });
}


  export const getAllKitTypes = async () => {
    try {
      const response = await fetch(`${environment.host}/core/kitType`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem("ACCESS_TOKEN")}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching metadata:', error);
    }
  }
